import $ from 'jquery';

const desktopHeaderNavigation = () => {
    // Main Navigation
    $('.desktop-menu a')
        .on('click', e => {
            if ($(e.target).siblings('.dropdown-menu').length > 0) {
                e.preventDefault();
            }
        });

    // Language Navigation
    $('.s-desktop-header .c-language-selector')
        .on('click', e => {
            if ($(e.target).siblings('.dropdown-menu').is(':visible')) {
                $(e.target).siblings('.dropdown-menu').slideUp();
            } else {
                $(e.target).siblings('.dropdown-menu').slideDown();
            }
        });

    $(document)
        .on('click', e => {
            const $languageSelector = $('.c-language-selector').find('.dropdown-menu');

            if ($(e.target).parents('.c-language-selector').length && !$(e.target).parents('.dropdown-menu').length) {
                e.preventDefault();
                e.stopPropagation();
            } else if ($languageSelector.is(':visible')) {
                $languageSelector.slideUp();
            }
        });
};

// doc ready
$(() => {
    desktopHeaderNavigation();
});



// WEBPACK FOOTER //
// ./src/sections/desktop-header/s-desktop-header.js